/* eslint-disable import/prefer-default-export */
export enum EVENT {
    SIGN_UP = 'sign_up',
    LOGIN = 'login',
    UPDATE_PROFILE = 'update_profile',
    LOAD_PAGE = 'load_page',
    PREVIEW = 'preview',
    PUBLISH = 'publish',
    CLICK_ADD_CUSTOM_DOMAIN_SIDEBAR = 'click_add_custom_domain_sidebar',
    CLICK_ADD_CUSTOM_DOMAIN_PUBLISH_DROPDOWN = 'click_add_custom_domain_publish_dropdown',
    ADD_CUSTOM_DOMAIN_POPUP_OPENED = 'add_custom_domain_popup_opened',
    CLICK_UPGRADE_ADD_CUSTOM_DOMAIN_POPUP = 'click_upgrade_add_custom_domain_popup',
    CLICK_PROMO_BANNER = 'click_promo_banner',
    CLICK_SECTION_TEMPLATE = 'click_section_template',
    CLICK_COLLECTION_TEMPLATE = 'click_collection_template',
    CLICK_COLLECTION_ITEM_PAGE_TEMPLATE = 'click_collection_item_page_template',
    LOAD_LOCK_SETTINGS_PAGE = 'load_lock_settings_page',
    CREATE_FORM = 'create_form',
    PUBLISH_FORM = 'publish_form',
    VIEW_SIGNUP_PAGE = 'view_signup_page',
    OPEN_CODE_INJECTION = 'open_code_injection',
    ADDED_CODE_INJECTION = 'added_code_injection',
    OPEN_CUSTOM_DOMAIN = 'open_custom_domain',
    CLICKED_STARTING_GUIDE = 'clicked_starting_guide',
    OPEN_PAGE_TEMPLATE = 'open_page_template',
    OPENED_HELP_RESOURCES = 'opened_help_resources',
    USED_HELP_RESOURCES = 'used_help_resources',
    OPEN_ANALYTICS = 'open_analytics',
    OPEN_PRODUCTS = 'open_products',
    OPEN_COLLABORATORS = 'open_collaborators',
    OPEN_SEO = 'open_seo',
    ADDED_SEO = 'added_seo',
    OPEN_FORMS = 'open_forms',
    ONBOARDING_STARTED = 'onboarding_started',
    ONBOARDING_FINISHED = 'onboarding_finished',
    OPEN_CMS = 'open_cms'
}
